import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getRandomColour } from '../js';

class Splash extends Component {
    initialState = {
        backgroundColor: '#fff'
    }

    state = { ...this.initialState };

    componentDidMount() {
        this.changeLoadingColours();
    }

    changeLoadingColours() {
        this.setState({
            backgroundColor: "bgColour--" + getRandomColour()
        })
        setTimeout(() => {
            this.changeLoadingColours();
        }, 5000);
    }

    render() {
        return (
            <div className="relative pageContainer">
                <div className={`background fade ${this.state.backgroundColor}`} style={{ opacity: 0.05 }} />
                <div style={{ paddingTop: 30 }} />
                <div className="commonShadow" style={styles.boxContainer}>
                    <div className="relative pageHeader paddingBottom-10" style={{ borderBottom: '1px solid #ccc' }}>
                        Piscary.fun
                    </div>
                    <div style={{ ...styles.redirectButton, marginTop: 42 }}>
                        coming soon
                    </div>
                </div>
            </div>
        );
    }
}
const styles = {
    boxContainer: {
        position: 'relative',
        maxWidth: 600,
        height: 'auto',
        margin: '0 auto',
        backgroundColor: '#fff',
        borderRadius: 5,
        padding: 16
    },
    redirectButton: {
        marginTop: 16,
        textAlign: 'center'
    }
}

export default connect(null, {})(withRouter(Splash));



// WEBPACK FOOTER //
// ./src/screens/Splash.js